import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { Button } from 'components/Form';
import { schedulePropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import { getClasspassSpotsAllocationMinMaxForStepper } from 'helpers/classpass-spots-allocation';
import { parseNumber } from 'helpers/core';

import './NetworkReservationsStepper.scss';

const NetworkReservationsStepper = ({
  currentClasspassSpots,
  decrementClasspassSpots,
  incrementClasspassSpots,
  schedule,
}) => {
  const { minClasspassSpots, maxClasspassSpots } = getClasspassSpotsAllocationMinMaxForStepper(schedule);
  const { isInThePast, classpassSoldOut, classpassAlmostSoldOut } = schedule;
  const hasAlert = !isInThePast && (classpassSoldOut || classpassAlmostSoldOut);

  const stepperValueClassNames = withMods('network-reservations-stepper__value', 'network-reservations-stepper__item', {
    classpassSoldOut: hasAlert && classpassSoldOut,
    classpassAlmostSoldOut: hasAlert && classpassAlmostSoldOut,
  });

  const normalize = value => {
    if (value < minClasspassSpots) return minClasspassSpots;
    if (value > maxClasspassSpots) return maxClasspassSpots;
    return value;
  };

  return (
    <div className="network-reservations-stepper">
      <Button
        className="network-reservations-stepper__item network-reservations-stepper__button"
        styled="primary-outline"
        onClick={() => decrementClasspassSpots()}
        disabled={currentClasspassSpots <= minClasspassSpots}>
        -
      </Button>
      <Field
        type="number"
        inputMode="decimal"
        name="classpassSpots"
        min={minClasspassSpots}
        max={maxClasspassSpots}
        className={stepperValueClassNames}
        component="input"
        normalize={normalize}
        parse={parseNumber}
      />
      <Button
        className="network-reservations-stepper__item network-reservations-stepper__button"
        styled="primary-outline"
        onClick={() => incrementClasspassSpots()}
        disabled={currentClasspassSpots >= maxClasspassSpots}>
        +
      </Button>
    </div>
  );
};

NetworkReservationsStepper.propTypes = {
  currentClasspassSpots: PropTypes.number,
  decrementClasspassSpots: PropTypes.func,
  incrementClasspassSpots: PropTypes.func,
  schedule: PropTypes.shape(schedulePropTypes),
};

export default NetworkReservationsStepper;
